import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Project_Create = BaseAnalyticsEvent.extend({
    name: z.literal("Project_Create")
});
export const Project_Delete = BaseAnalyticsEvent.extend({
    name: z.literal("Project_Delete")
});
export const Project_AssignApplication = BaseAnalyticsEvent.extend({
    name: z.literal("Project_AssignApplication")
});
export const Project_RemoveApplication = BaseAnalyticsEvent.extend({
    name: z.literal("Project_RemoveApplication")
});
